import { apiSlice } from './baseApi';
import axiosPublic from '@api/axiosPublic';

export const subscriptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanUsage: builder.query({
      query: () => ({ url: '/subscriptions/usage', method: 'GET' }),
      providesTags: ['Subscription', 'Orders', 'Users'],
    }),
    getPlanCatalog: builder.query({
      async queryFn(country) {
        try {
          const { data } = await axiosPublic.get('/subscriptions/plans', { params: { country: country || 'GE' } });
          return { data };
        } catch (error) {
          return { error: { status: error.response?.status, data: error.response?.data } };
        }
      },
    }),
    getSubscriptionPlans: builder.query({
      async queryFn() {
        try {
          const { data } = await axiosPublic.get('/subscriptions/plans');
          return { data: data.plans };
        } catch (error) {
          return { error: { status: error.response?.status, data: error.response?.data } };
        }
      },
    }),
    getSubscriptionStatus: builder.query({
      query: ({ company_id }) => ({
        url: `/subscriptions/status?company_id=${encodeURIComponent(company_id)}`,
        method: 'GET',
      }),
      transformResponse: (response) => response?.subscription ?? null,
      providesTags: ['Subscription'],
    }),
    getSubscriptionUpgradeQuote: builder.query({
      query: ({ company_id }) => ({
        url: `/subscriptions/upgrade-quote?company_id=${encodeURIComponent(company_id)}`,
        method: 'GET',
      }),
    }),
    getSubscriptionPayments: builder.query({
      query: ({ company_id }) => ({
        url: `/subscriptions/payments?company_id=${encodeURIComponent(company_id)}`,
        method: 'GET',
      }),
      transformResponse: (response) => response?.payments ?? [],
      providesTags: ['Subscription'],
    }),
    initiateSubscription: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/initiate',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
    changeSubscriptionPlan: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/change-plan',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
    reconcileSubscriptionCheckout: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/reconcile',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
    cancelSubscription: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/cancel',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
    retrySubscription: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/retry',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
    updateSubscriptionCard: builder.mutation({
      query: (body) => ({
        url: '/subscriptions/update-card',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Subscription'],
    }),
  }),
});
